<!-- <p class="text-center" style="color:brown">Dashboard v2 (New Druid) - {{userType}}</p> -->
<systemv2-dashboard *ngIf="userType==='SYSTEM'"></systemv2-dashboard>
<merchantv2-dashboard *ngIf="userType==='MERCHANT'"></merchantv2-dashboard>
<isov2-dashboard *ngIf="userType==='ISO'"></isov2-dashboard>
<isov2-dashboard *ngIf="userType==='SUB_ISO'"></isov2-dashboard>
<merchantv2-dashboard *ngIf="userType==='STORE_MANAGER'"></merchantv2-dashboard>